import { render, staticRenderFns } from "./TransferGoodsReceived.vue?vue&type=template&id=6bd97376&scoped=true&"
import script from "./TransferGoodsReceived.vue?vue&type=script&lang=js&"
export * from "./TransferGoodsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd97376",
  null
  
)

export default component.exports